module.exports = {"230103001":"花园街道","230103002":"奋斗路街道","230103003":"革新街道","230103004":"文化街道","230103005":"大成街道","230103006":"芦家街道","230103007":"荣市街道","230103009":"燎原街道","230103010":"松花江街道","230103011":"曲线街道","230103012":"通达街道","230103013":"七政街道","230103015":"和兴路街道","230103016":"哈西街道","230103017":"保健路街道","230103018":"先锋路街道","230103019":"新春街道","230103020":"跃进街道","230103101":"王岗镇","230103201":"红旗满族乡","230103500":"红旗农场","230103579":"南岗区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230103.json
// module id = 616
// module chunks = 0